import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { useIsAuthenticated } from "@azure/msal-react";
import { Link } from "react-router-dom";
import LoginButton from "./LoginButton";
import LogoutButton from "./LogoutButton";

const Navigation: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();

  return (
    <Navbar bg="primary" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/">
          Demo Azure AD
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/">
              Inicio
            </Nav.Link>
            {isAuthenticated && (
              <Nav.Link as={Link} to="/profile">
                Mi Perfil
              </Nav.Link>
            )}
          </Nav>
          <Nav>
            {isAuthenticated ? <LogoutButton /> : <LoginButton />}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
